import { Component, OnInit, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ControlExecutionOverviewModel } from "@app/controls/models/control-execution/control-execution-overview-model";
import { GenericPaginationListConfig } from "@app/shared/models/GenericPaginationList/GenericPaginationListConfig";
import { Pages } from "@constants/pages/Pages";
import { FormatType } from "@enums/FormatType";
import { nameof } from "@methods/jeffs-toolkit";
import { TabService } from "@services/tabs/TabService";
import { EffPopupHeaderComponent } from "@app/controls/testing/advanced/detail-new/common/popups/eff-popup-header/eff-popup-header.component";
import { SharedModule } from "@app/shared/shared.module";

@Component({
    selector: "sources-popup",
    templateUrl: "./sources-population-popup.component.html",
    styleUrls: ["./sources-population-popup.component.scss"],
    imports: [EffPopupHeaderComponent, SharedModule]
})
export class SourcesPopulationPopupComponent implements OnInit {
    data = inject(MAT_DIALOG_DATA);
    private _tabService = inject(TabService);
    private _pages = inject(Pages);
    dialogRef = inject<MatDialogRef<SourcesPopulationPopupComponent>>(MatDialogRef);

    executionData: ControlExecutionOverviewModel[] = [];
    title: string;
    executionConfig: GenericPaginationListConfig;

    constructor() {
        this.executionData = this.data.executionData;
        this.title = this.data.title;
    }

    ngOnInit(): void {
        this.createExecutionConfig();
    }

    close() {
        this.dialogRef.close();
    }

    private createExecutionConfig() {
        if (this.executionConfig) {
            return;
        }

        this.executionConfig = <GenericPaginationListConfig>{
            name: "Control Execution population",
            idProp: nameof<ControlExecutionOverviewModel>((x) => x.guid),
            sortProp: nameof<ControlExecutionOverviewModel>((x) => x.actionDate),
            overviewSortBy: nameof<ControlExecutionOverviewModel>((x) => x.actionDate),
            uiid: "control-execution-population-popup-overview",
            isSortableByColumn: true,

            allowEdit: true,

            fields: [
                {
                    fieldName: nameof<ControlExecutionOverviewModel>((x) => x.identifier),
                    prettyName: "ID",
                    headerCssClass: "th-fixed-short",
                },
                {
                    fieldName: nameof<ControlExecutionOverviewModel>((x) => x.name),
                    prettyName: "Name",
                    headerCssClass: "th-fixed-default",
                },
                {
                    fieldName: nameof<ControlExecutionOverviewModel>((x) => x.statusDescription),
                    prettyName: "Status",
                    headerCssClass: "th-max-short",
                },
                {
                    fieldName: nameof<ControlExecutionOverviewModel>((x) => x.scoreName),
                    prettyName: "Score",
                    headerCssClass: "th-max-default",
                },
                {
                    fieldName: nameof<ControlExecutionOverviewModel>((x) => x.actionDate),
                    prettyName: "Action date",
                    formatType: FormatType.DateFormat,
                    headerCssClass: "th-max-short",
                },
                {
                    fieldName: nameof<ControlExecutionOverviewModel>((x) => x.completedAt),
                    prettyName: "Completed",
                    formatType: FormatType.DateFormat,
                    headerCssClass: "th-max-short",
                },
            ],

            data: this.executionData,
            editOverride: (row) => {
                this.dialogRef.close();
                this._tabService.generateTab(this._pages.TaskDetail, row.guid, "Control Execution");
            },
            setAdditionalColumns: (row) => {
                for (const item of row) {
                    switch (item.statusDescription) {
                        case "To do":
                            item.statusDescription_ICON = "fa-circle-xmark";
                            item.statusDescription_COLOR_CLASS = "status-error";
                            break;
                        case "Ready for Review":
                        case "Rejected":
                            item.statusDescription_ICON = "fa-circle-minus";
                            item.statusDescription_COLOR_CLASS = "status-attention";
                            break;
                        case "Done":
                            item.statusDescription_ICON = "fa-circle-check";
                            item.statusDescription_COLOR_CLASS = "status-success";
                            break;
                    }

                    if (!item.scoreName || item.scoreName.length === 0) {
                        item.scoreName = "No score";
                        item.scoreName_COLOR = null;
                    }
                }
            },
        };
    }
}
